import { useEffect } from 'react'

import { mbusinessApi } from 'redux/services/mbusiness'
import { GetMbusinessParams } from 'redux/services/mbusiness/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetMbusinessParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = mbusinessApi.useLazyMbusinessStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
